import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {signOut} from 'aws-amplify/auth';
import {reducersState} from '../../redux/reducers';
//@ts-ignore
import {SchoolHeader} from '@PikaDoApp/pikado-web-dsm';

/**
 * App-specific Header implementation
 *
 * This component:
 * 1. Handles app-specific logic (Redux, navigation, auth)
 * 2. Provides data and callbacks to the SchoolHeader component from DSM
 * 3. Manages local state for loading states
 * 4. Integrates with your app's routing and state management
 */
const AppHeader: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get user/school data from Redux store
  const school = useSelector((state: reducersState) => state.user?.school);
  // Local state for loading operations
  const [isLoading, setIsLoading] = useState<boolean>(false);

  /**
   * Handles user logout process
   * - Shows loading state
   * - Signs out from AWS Amplify
   * - Resets Redux user state
   * - Navigates to home page
   * - Handles errors gracefully
   */
  const handleLogout = async () => {
    try {
      setIsLoading(true);
      // Sign out from AWS Amplify
      await signOut();

      // Reset user state in Redux
      await dispatch({type: 'RESET_USER'});

      // Navigate to home/login page
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Prepare data for the Header component
  const userName = school?.name || 'Guest';
  const homePath = `/school/${school?.id || ''}`;

  // Handle logo click - navigate to home
  const handleLogoClick = () => {
    navigate(homePath);
  };

  // Handle report button click - navigate to home
  const handleReportButtonClick = () => {
    navigate(homePath);
  };

  // Settings dropdown items
  const settingItems = [
    {
      label: 'Sign out',
      action: handleLogout,
    },
  ];

  return (
    <SchoolHeader
      welcomeText={`Welcome ${userName}`}
      onLogoClick={handleLogoClick}
      studentOptions={[]} // Empty array as requested
      onStudentAdd={() => {}} // No-op function
      settingItems={settingItems}
      onTextButtonClick={handleReportButtonClick}
      ReportButtonText="Home"
      disableStudentDropdown={true}
      selectedStudent={{
        id: '',
        name:userName
      }}
      isLoading={isLoading}
      loaderText="Signing out..."
      partnerMode={false}
    />
  );
};

export default AppHeader;
